// extracted by mini-css-extract-plugin
module.exports = {"bundle-banner":"BundleBanner_bundle-banner__dKPXN","bundle-banner-container":"BundleBanner_bundle-banner-container__8x44K","icon":"BundleBanner_icon__rTyN5"};